import { useState } from 'react';
import styles from './LoginComponent.module.css';

export default function LoginComponent(props) {
    // ----- STATE INITIALIZATION -----
    const { 
        handleLogin, 
        email, 
        setEmail, 
        password, 
        setPassword, 
        error, 
        setError,
        signUpRedirect,
        setUp,
        loading
    } = props;

    const [ inputType, setInputType ] = useState('password');

    // handle inputs
    const handleInputChange = (setter) => (e) => {
        if (error) setError(false);
        setter(e.target.value);
    };

    const isFormIncomplete = email.length < 1 || password.length < 1 || loading;

    return (
        <form className={styles.form} onSubmit={e => handleLogin(e)}>
            <h2 className='text-center mb-2'>Login</h2>
            {setUp !== true && 
                <div className={styles.needAccount}>
                    Need an account? <span onClick={signUpRedirect}>SIGN UP</span>
                </div>
            }
            <div className={styles.inputGroup}>
                <input
                    type='email'
                    id='login-email'
                    value={email}
                    className={styles.input}
                    onChange={handleInputChange(setEmail)}
                    required
                    autoComplete='email'
                />
                <label htmlFor='login-email' className={styles.label}>Email</label>
            </div>
            <div className={styles.inputGroup}>
                <input
                    type={inputType}
                    id='login-password'
                    value={password}
                    onChange={handleInputChange(setPassword)}
                    className={styles.input}
                    required
                    autoComplete='current-password'
                />
                <label htmlFor='login-password' className={styles.label}>Password</label>
                <button 
                    type='button' 
                    className={styles.hidePassword} 
                    onClick={() => setInputType(inputType === 'password' ? 'text' : 'password')} 
                    disabled={password?.length < 1}
                    aria-label={inputType === 'password' ? 'Show Password' : 'Hide Password'}
                >
                    {inputType === 'password' ? <i className='fas fa-eye' /> : <i className='fas fa-eye-slash' />}
                </button>
                <a className={styles.forgotPassword} href={`/reset`}>Forgot password?</a>
            </div>
            <div className={styles.inputGroup} style={{flexDirection: 'column', justifyContent: 'center', alignItems: 'center'}}>
                <button 
                    type='submit'
                    className={styles.btn} 
                    disabled={isFormIncomplete}
                >
                    {loading ? 'Loading...' : 'Submit'}
                </button>
                {error && <p className='text-center' style={{color: 'red'}}>Email or password is incorrect.</p>}
            </div>
        </form>
    );
};